import * as Yup from 'yup';

export const RehireDispatcherSchema = Yup.object().shape({
    startDate: Yup.string().required('Start date is required'),
    phoneNumber: Yup.string().required('Phone number is required'),
    profilePicture: Yup.array()
        .required('Profile picture is required')
        .min(1, 'Please upload a profile picture'),
    address: Yup.string().required('House address is required'),
    employmentType: Yup.string().required('Employment type is required'),
});

export type RehireDispatcherDataType = Yup.InferType<typeof RehireDispatcherSchema>;

type InitialValues = {
    startDate: string;
    phoneNumber: string;
    profilePicture: File[];
    address: string;
    // plateNumber: string;
    employmentType: string;
};

export const RehireDispatcherInitialValues: InitialValues = {
    startDate: '',
    phoneNumber: '',
    profilePicture: [],
    address: '',
    // plateNumber: '',
    employmentType: '',
};

export interface RehireDispatcherInterface {
    startDate: string;
    phoneNumber: string;
    profilePicture: File[];
    address: string;
    // plateNumber: string;
    driverId?: string;
    employmentType: string;
}
